import type { QrResolution } from './resolveQrCode'

export const getQrNavigationPath = (
  resolution: Extract<QrResolution, { status: 'resolved' | 'unavailable' }>
) => resolution.path
